
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-whatsapp" })
export default class IconWhatsapp extends Vue {
  sData: string = require("@icon/line-awesome/whatsapp.svg");
}
